import Dashboard from "layouts/dashboard";
import SignIn from "layouts/authentication/sign-in";
import Empresas from "layouts/Empresas";
import Billing from "layouts/billing";
import ProtectedRoute from "components/ProtectedRoute";
import Icon from "@mui/material/Icon";
import Overview from "layouts/profile";

/* Módulos adicionales (crea estos layouts progresivamente) */
import Ventas from "layouts/ventas";
import Clientes_y_CRM from "layouts/Clientes_y_CRM";
import Compras from "layouts/compras";
import Inventario from "layouts/inventario";
import Contabilidad from "layouts/contabilidad";
import RecursosHumanos from "layouts/rrhh";
import Logistica from "layouts/logistica";
import Reportes from "layouts/reportes";
import Configuracion from "layouts/Configuracion";
import Auditoria from "layouts/Auditoria";
import Soporte from "layouts/soporte";

const routes = [
  /* ====== PANEL GENERAL ====== */
  {
    type: "collapse",
    name: "Dashboard General",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Empresas",
    key: "empresas",
    icon: <Icon fontSize="small">store</Icon>,
    route: "/empresas",
    component: (
      <ProtectedRoute>
        <Empresas />
      </ProtectedRoute>
    ),
  },

  /* ====== MÓDULOS EMPRESARIALES ====== */
  {
    type: "title",
    title: "Gestión Empresarial",
    key: "gestion-empresarial",
  },
  {
    type: "collapse",
    name: "Ventas y Facturación",
    key: "ventas",
    icon: <Icon fontSize="small">point_of_sale</Icon>,
    route: "/ventas",
    component: (
      <ProtectedRoute>
        <Ventas />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Clientes y CRM",
    key: "clientes-crm",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/clientes-crm",
    component: (
      <ProtectedRoute>
        <Clientes_y_CRM />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Compras y Proveedores",
    key: "compras",
    icon: <Icon fontSize="small">shopping_cart</Icon>,
    route: "/compras",
    component: (
      <ProtectedRoute>
        <Compras />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Inventario",
    key: "inventario",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/inventario",
    component: (
      <ProtectedRoute>
        <Inventario />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Contabilidad",
    key: "contabilidad",
    icon: <Icon fontSize="small">account_balance</Icon>,
    route: "/contabilidad",
    component: (
      <ProtectedRoute>
        <Contabilidad />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Recursos Humanos",
    key: "rrhh",
    icon: <Icon fontSize="small">people_alt</Icon>,
    route: "/rrhh",
    component: (
      <ProtectedRoute>
        <RecursosHumanos />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Logística",
    key: "logistica",
    icon: <Icon fontSize="small">local_shipping</Icon>,
    route: "/logistica",
    component: (
      <ProtectedRoute>
        <Logistica />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Reportes",
    key: "reportes",
    icon: <Icon fontSize="small">bar_chart</Icon>,
    route: "/reportes",
    component: (
      <ProtectedRoute>
        <Reportes />
      </ProtectedRoute>
    ),
  },

  /* ====== ADMINISTRACIÓN ====== */
  {
    type: "title",
    title: "Administración del Sistema",
    key: "administracion-sistema",
  },
  {
    type: "collapse",
    name: "Usuarios y Roles",
    key: "users-roles",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/users-roles",
    component: (
      <ProtectedRoute>
        <Billing />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Configuración",
    key: "configuracion",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/configuracion",
    component: (
      <ProtectedRoute>
        <Configuracion />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Auditoría / Logs",
    key: "auditoria",
    icon: <Icon fontSize="small">fact_check</Icon>,
    route: "/auditoria",
    component: (
      <ProtectedRoute>
        <Auditoria />
      </ProtectedRoute>
    ),
  },

  /* ====== SOPORTE ====== */
  {
    type: "title",
    title: "Soporte",
    key: "soporte-title",
  },
  {
    type: "collapse",
    name: "Centro de Ayuda",
    key: "soporte",
    icon: <Icon fontSize="small">help_outline</Icon>,
    route: "/soporte",
    component: (
      <ProtectedRoute>
        <Soporte />
      </ProtectedRoute>
    ),
  },

  /* ====== RUTAS OCULTAS ====== */
  {
    type: "hidden",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "hidden",
    key: "profile",
    route: "/profile",
    component: <Overview />,
  },
  {
    type: "hidden",
    key: "dashboard-empresa",
    route: "/dashboard/:id",
    component: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
];

export default routes;
